// Sort state for a table whose headers are buttons. `sort` is '' when the list is in its default order.

// What clicking a column header does: a new column sorts ascending (descending for a numeric one,
// where the big numbers are what you want first); the sorted column flips its direction.
export function nextSort({ sort, dir }, key, descFirst = false, defaultKey = '') {
  const current = sort || defaultKey;
  if (current === key) return { sort: key, dir: (dir || 'asc') === 'asc' ? 'desc' : 'asc' };
  return { sort: key, dir: descFirst ? 'desc' : 'asc' };
}
